export const formatLiteral = (money: number) => {
  if (money >= 1e11) {
    return `${(Math.round(money / 1e4) / 1e5).toFixed(0)}B`;
  }

  if (money >= 1e9) {
    return `${(Math.round(money / 1e4) / 1e5).toFixed(2)}B`;
  }

  if (money >= 1e8) {
    return `${(Math.round(money / 1e4) / 100).toFixed(0)}M`;
  }

  if (money >= 1e6) {
    return `${(Math.round(money / 1e4) / 100).toFixed(2)}M`;
  }

  return money.toString();
};
